import { render } from "./PrefixDois.vue?vue&type=template&id=045cdfbe&scoped=true"
import script from "./PrefixDois.vue?vue&type=script&lang=js"
export * from "./PrefixDois.vue?vue&type=script&lang=js"

import "./PrefixDois.vue?vue&type=style&index=0&id=045cdfbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045cdfbe"]])

export default __exports__